import Vue from 'vue'
import Library from 'library'
import { merge } from 'lodash'

import * as entities from './entities'

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA6L6s9jSh3MQdPGSIT9-G8E8LrApVvxto'
  }
})

Library.Entities = merge(Library.Entities, entities)

export default Library
